import { REJECT_ORDINARY_PERMISSION, RESET_ORDINARY_PERMISSION, ALLOW_PROCEED_ORDINARY } from './actions'

const initial = { isValid: false, type: 'NOT_VALIDATED' }
export const reducer = (state = initial, action) => {
  switch (action.type) {
    case REJECT_ORDINARY_PERMISSION:
      return action.payload
    case RESET_ORDINARY_PERMISSION:
      return initial
    case ALLOW_PROCEED_ORDINARY:
      return { isValid: true, type: 'VALID' }
    default:
      return state
  }
}
